const POSTHOG_KEY = 'phc_xAvL2Iq4tFmANRE7kzbKwaSqp1HJjN7x48s3vr0CMjs';
const POSTHOG_HOST = 'https://us.i.posthog.com';
const GA_MEASUREMENT_ID = 'G-7K9QRZD69Z';

let posthogRequested = false;
let gaRequested = false;

export const loadPostHog = () => {
  if (posthogRequested || typeof window === 'undefined') return;
  posthogRequested = true;

  const run = () => {
    (function (documentRef, posthogRef) {
      let methodName;
      let index;
      let script;
      let firstScript;

      if (posthogRef.__SV) return;

      window.posthog = posthogRef;
      posthogRef._i = [];
      posthogRef.init = function (key, options, name) {
        function addStub(target, method) {
          const parts = method.split('.');
          if (parts.length === 2) {
            target = target[parts[0]];
            method = parts[1];
          }
          target[method] = function () {
            target.push([method].concat(Array.prototype.slice.call(arguments, 0)));
          };
        }

        script = documentRef.createElement('script');
        script.type = 'text/javascript';
        script.crossOrigin = 'anonymous';
        script.async = true;
        script.src = options.api_host.replace('.i.posthog.com', '-assets.i.posthog.com') + '/static/array.js';
        firstScript = documentRef.getElementsByTagName('script')[0];
        firstScript.parentNode.insertBefore(script, firstScript);

        let target = posthogRef;
        if (name !== undefined) {
          target = posthogRef[name] = [];
        } else {
          name = 'posthog';
        }
        target.people = target.people || [];
        target.toString = function (withPeople) {
          let label = 'posthog';
          if (name !== 'posthog') label += '.' + name;
          if (!withPeople) label += ' (stub)';
          return label;
        };
        target.people.toString = function () {
          return target.toString(1) + '.people (stub)';
        };

        const methods = 'init capture identify reset opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing get_distinct_id get_session_id'.split(' ');
        for (index = 0; index < methods.length; index += 1) {
          methodName = methods[index];
          addStub(target, methodName);
        }

        posthogRef._i.push([key, options, name]);
      };
      posthogRef.__SV = 1;
    })(document, window.posthog || []);

    window.posthog.init(POSTHOG_KEY, {
      api_host: POSTHOG_HOST,
      person_profiles: 'identified_only',
      session_recording: {
        recordCrossOriginIframes: true,
        capturePerformance: false,
      },
    });
  };

  const schedule = window.requestIdleCallback || ((cb) => window.setTimeout(cb, 1500));
  schedule(run);
};

export const loadGoogleAnalytics = () => {
  if (gaRequested || typeof window === 'undefined') return;
  gaRequested = true;

  const run = () => {
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag('js', new Date());
    window.gtag('config', GA_MEASUREMENT_ID, {
      anonymize_ip: true,
    });
  };

  const schedule = window.requestIdleCallback || ((cb) => window.setTimeout(cb, 1500));
  schedule(run);
};

export const trackPageView = (path) => {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
  window.gtag('event', 'page_view', {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
};

// Fire a custom event to both GA4 and PostHog if either is loaded.
// Safe to call before consent — silently does nothing if analytics aren't ready.
export const trackEvent = (name, params = {}) => {
  if (typeof window === 'undefined') return;
  if (typeof window.gtag === 'function') {
    window.gtag('event', name, params);
  }
  if (window.posthog && typeof window.posthog.capture === 'function') {
    window.posthog.capture(name, params);
  }
};
